__turbopack_context__.v({
  "bottom": "split-container-module__xzDTtq__bottom",
  "container": "split-container-module__xzDTtq__container",
  "top": "split-container-module__xzDTtq__top",
});
